export default "__VITE_ASSET__859c9074__"